import { NotificationTypes, INotificationInfo }from "./notification.types"

export type NotificationAction = 
    | { type: typeof NotificationTypes.CREATE_NOTIFICATION, payload: INotificationInfo }
    | { type: typeof NotificationTypes.CLEAR_NOTIFICATION }

export const createNotification = (payload: INotificationInfo): NotificationAction => {
    return {
        type: NotificationTypes.CREATE_NOTIFICATION,
        payload,
    }
}

export const clearNotification = (): NotificationAction => {
    return {
        type: NotificationTypes.CLEAR_NOTIFICATION
    }
}
